import createIcon from '../../createIcon';

/**
 * @component @name Tapas
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuMjUgMTBWMUgxNC4yNVYxMEMxNC4yNSAxMS44NiAxNS41MyAxMy40MSAxNy4yNSAxMy44NlYyMUgxNS4yNVYyM0gyMS4yNVYyMUgxOS4yNVYxMy44NkMyMC45NyAxMy40MSAyMi4yNSAxMS44NiAyMi4yNSAxMFpNMjAuMjUgM1Y2SDE2LjI1VjNIMjAuMjVaTTEyLjc1IDExLjVDMTIuNzUgMTIuODggMTEuNjMgMTQgMTAuMjUgMTRIOC4yNVYyM0g2LjI1VjE0SDQuMjVDMi44NyAxNCAxLjc1IDEyLjg4IDEuNzUgMTEuNUMxLjc1IDEwLjEyIDIuODcgOSA0LjI1IDlINi4yNVY4SDQuMjVDMi44NyA4IDEuNzUgNi44OCAxLjc1IDUuNUMxLjc1IDQuMTIgMi44NyAzIDQuMjUgM0g2LjI1VjFIOC4yNVYzSDEwLjI1QzExLjYzIDMgMTIuNzUgNC4xMiAxMi43NSA1LjVDMTIuNzUgNi44OCAxMS42MyA4IDEwLjI1IDhIOC4yNVY5SDEwLjI1QzExLjYzIDkgMTIuNzUgMTAuMTIgMTIuNzUgMTEuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tapas = createIcon('Tapas', [
  [
    'path',
    {
      d: 'M22.25 10V1H14.25V10C14.25 11.86 15.53 13.41 17.25 13.86V21H15.25V23H21.25V21H19.25V13.86C20.97 13.41 22.25 11.86 22.25 10ZM20.25 3V6H16.25V3H20.25ZM12.75 11.5C12.75 12.88 11.63 14 10.25 14H8.25V23H6.25V14H4.25C2.87 14 1.75 12.88 1.75 11.5C1.75 10.12 2.87 9 4.25 9H6.25V8H4.25C2.87 8 1.75 6.88 1.75 5.5C1.75 4.12 2.87 3 4.25 3H6.25V1H8.25V3H10.25C11.63 3 12.75 4.12 12.75 5.5C12.75 6.88 11.63 8 10.25 8H8.25V9H10.25C11.63 9 12.75 10.12 12.75 11.5Z',
      key: 'jhyqu6',
    },
  ],
]);

export default Tapas;
